import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-logout-system',
  templateUrl: './logout-system.component.html',
  styleUrls: ['./logout-system.component.scss']
})
export class LogoutSystemComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {

    localStorage.clear();

  }

}
